import React from 'react';
import styled from '@emotion/styled';

const Container = styled.div`
  position: relative;
  height: 8px;
  margin-top: 10px;
`;

const BaseBar = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border-radius: 4px;
  background-color: #f8f8f8;
`;

const FillBar = styled(BaseBar)`
  background-color: #f0ad4e;
  width: ${({ percentage }) => percentage}%;
`;

// eslint-disable-next-line react/prop-types
const ProgressBar = ({ percentage = 0 }) => {
  return (
    <Container className="member-center-profile__progress-bar">
      <BaseBar className="member-center-profile__progress-bar-background" />
      <FillBar percentage={percentage} />
    </Container>
  );
};

export default ProgressBar;
